import axios from "axios";

/**
 * Parses tokens from a URL hash fragment.
 * Supports: /auth-login#accessToken=JWT&refreshToken=REFRESH
 */
export function parseHashTokens(hash = window.location.hash) {
  const params = new URLSearchParams(hash.replace(/^#/, ""));
  return {
    accessToken: params.get("accessToken"),
    refreshToken: params.get("refreshToken"),
  };
}

/**
 * Decodes a JWT payload without verifying the signature.
 * Returns null if the token is malformed.
 */
export function decodeJWT(token) {
  try {
    const payload = token.split(".")[1];
    const base64 = payload.replace(/-/g, "+").replace(/_/g, "/");
    return JSON.parse(
      decodeURIComponent(
        atob(base64)
          .split("")
          .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
          .join(""),
      ),
    );
  } catch {
    return null;
  }
}

/**
 * Returns true if the JWT is present and not yet expired.
 */
export function isTokenValid(token) {
  if (!token) return false;
  const decoded = decodeJWT(token);
  if (!decoded) return false;
  if (!decoded.exp) return true; // no expiry claim — treat as valid
  return decoded.exp * 1000 > Date.now();
}

/**
 * Persists tokens to localStorage in the format expected by the existing
 * auth action files: { data: { jwtToken, refreshToken } }
 */
export function storeTokens(accessToken, refreshToken) {
  const userAuth = {
    data: {
      jwtToken: accessToken,
      refreshToken: refreshToken,
      isPasswordSet: true,
    },
  };
  localStorage.setItem("userAuth", JSON.stringify(userAuth));
  localStorage.setItem("isLoggedIn", "true");
}

/**
 * Sets the global Axios default Authorization header.
 */
export function setAxiosAuthHeader(token) {
  axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
}

/**
 * Removes all auth-related keys from localStorage.
 */
export function clearAuthStorage() {
  localStorage.removeItem("userAuth");
  localStorage.removeItem("userData");
  localStorage.removeItem("isLoggedIn");
  localStorage.removeItem("isPasswordSet");
  localStorage.removeItem("notificationData");
  delete axios.defaults.headers.common["Authorization"];
}

/**
 * Strips the hash fragment from the current URL without triggering a
 * navigation or a page reload.
 */
export function cleanHashFromURL() {
  const cleanURL = window.location.pathname + (window.location.search || "");
  window.history.replaceState(null, "", cleanURL);
}
